<template>
  <!-- Modal -->
        <div class="modal fade" ref="vuemodal" id="modalFinalizarCompra" tabindex="-1" role="dialog" aria-labelledby="addNew" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">

                <keep-alive>
                    <component
                            v-bind:is="currentTabComponent"
                            v-on:componente-ativo="ouvirEvento"
                            v-bind:inquilino="inquilino"
                            v-bind:usuario="usuario"
                            v-bind:valorItens="valorItens"
                            v-bind:valorTotal="valorTotal"

                            v-bind:dados_entrega="dados_entrega"
                            v-bind:dados_pagamento="dados_pagamento"
                            v-bind:dados_produtos="dados_produtos"
                        >
                    </component>
                </keep-alive>

            </div>
        </div>
</template>

<script>
import api from "../service/api";

export default {

    data () {
        return {
            carregando:false,
            inquilino:{},
            currentTab: "endereco",
            tabs: ["tudo-temp", "endereco", "pagamento"],

            //dados Salvos
            //dados entrega
            dados_entrega: {
                on:false,
                entrega_id: null,
                endereco_id: null,
                frete: null,
                endereco_formatado: null
            },
            //dads Pagamento
            dados_pagamento: {
                pagamento_id: null,
                troco: null,
                bandeira_id: null,
                cupom_id: null,
                desconto: null
            },
            //dados dos Produtos
            dados_produtos: [],
        }
    },

    computed: {
        currentTabComponent: function() {
            return "fc-" + this.currentTab.toLowerCase();
        },

        usuario() {

            if (JSON.stringify(this.$store.state.perfil.main)==='{}') {
                return null
            }else{
                return this.$store.state.perfil.main
            }
        },

        produtosDoCarrinho() {
            return this.$store.state.produtosSelecionados.main;
        },

        valorItens(){

            let valorProduto = 0;

            for (let index = 0; index < this.produtosDoCarrinho.length; index++) {
                valorProduto += this.setarValor(this.produtosDoCarrinho[index])
            }

            return valorProduto;
        },

        valorTotal(){
            return this.valorItens+this.dados_entrega.frete-this.dados_pagamento.desconto;
        }
    },

    methods: {

        montarProdutos(){

            for (let index = 0; index < this.produtosDoCarrinho.length; index++) {

                let prod = this.produtosDoCarrinho[index];

                prod.valor_total = this.setarValor(this.produtosDoCarrinho[index])

                this.dados_produtos.push(prod);

            };


        },

        async carregarInquilino(){

            this.carregando = true;
            await api
            .get('/inquilino')
            .then(response => (this.inquilino = response.data));

            this.carregando = false
        },

        ouvirEvento(evento){

            if (evento.endereco) {
                this.dados_entrega.endereco_id = evento.endereco.endereco_id;
                this.dados_entrega.entrega_id = evento.endereco.entrega_id;
                this.dados_entrega.frete = evento.endereco.frete;
                this.dados_entrega.endereco_formatado = evento.endereco.endereco_formatado;
            }

            if (evento.pagamento) {
                this.dados_pagamento.pagamento_id = evento.pagamento.pagamento_id;
                this.dados_pagamento.troco = evento.pagamento.troco;
                this.dados_pagamento.bandeira_id = evento.pagamento.bandeira_id;
                this.dados_pagamento.bandeira_nome = evento.pagamento.bandeira_nome;
                this.dados_pagamento.cupom_id = evento.pagamento.cupom_id;
                this.dados_pagamento.desconto = evento.pagamento.desconto;

            }

            this.currentTab = evento.pagina;
            $('#modalFinalizarCompra').animate({ scrollTop: 0 }, 'slow');
        },

        setarValor(item) {

            if (item.tipo==1) {
                let valorProduto = 0;
                let valorOpcional = 0;
                let valorAdicional = 0;
                let valorEtapas = 0;

                if (item.produto.promocao) {
                    valorProduto += parseFloat(item.produto.promocao.valor);
                }else{
                    valorProduto += parseFloat(item.produto.valor);
                }

                if (item.produto.grupoopcional) {
                    if (item.produto.grupoopcional.multipla_escolha==1) {
                        for (let index = 0; index < item.opcionais.length; index++) {
                            valorOpcional += parseFloat(item.opcionais[index].valor)
                        }
                    }else{
                        if (item.opcionais.valor) {
                            valorOpcional += parseFloat(item.opcionais.valor)
                        }else{
                            valorOpcional += 0
                        }
                    }

                }


                /* for (let index = 0; index < item.opcionais.length; index++) {
                    valorOpcional += parseFloat(item.opcionais[index].valor)
                } */

                for (let index = 0; index < item.adicionais.length; index++) {
                    valorAdicional += parseFloat(item.adicionais[index].valor)
                }

                for (let index = 0; index < item.etapas.length; index++) {
                    valorEtapas += parseFloat(item.etapas[index].pivot.valor)
                }

                return item.quantidade*(valorProduto+valorOpcional+valorAdicional+valorEtapas)

            }else if(item.tipo==2){

                let valorTotalSabores = parseFloat(0);
                let valorBorda = parseFloat(item.borda.valor??0);
                let valorMassa = parseFloat(item.massa.valor??0);
                let valorAdicional = 0;
                let valorSabor = 0;

                for (let index = 0; index < item.sabores.length; index++) {

                    if (item.sabores[index].promocao) {
                        valorTotalSabores += parseFloat(item.sabores[index].promocao.valor);
                    }else{
                        valorTotalSabores += parseFloat(item.sabores[index].valor)
                    }

                }

                if (item.sabores.length>0) {
                    valorSabor = valorTotalSabores/item.sabores.length;
                }

                for (let index = 0; index < item.tamanho.adicionais.length; index++) {
                    valorAdicional += parseFloat(item.tamanho.adicionais[index].valor)
                }

                return item.quantidade*(valorSabor+valorBorda+valorMassa+valorAdicional)

            }else if(item.tipo==3){

                let valorPizza = parseFloat(item.valor);
                let valorTotal = parseFloat(0);
                let valorAdicionais = parseFloat(0);

                for (let index = 0; index < item.produtos.length; index++) {
                    valorTotal += parseFloat(item.produtos[index].borda.valor??0);
                    valorTotal += parseFloat(item.produtos[index].massa.valor??0);

                    item.produtos[index].adicionais.forEach(adicional => {
                        valorAdicionais += parseFloat(adicional.valor||0);
                    });
                }

                return item.quantidade*(valorPizza+valorTotal+valorAdicionais);

            }



        },

        async fecharModal(){
            await this.$store.dispatch('hideAllModals').then();
        }

    },

    mounted() {
        $(this.$refs.vuemodal).on("hidden.bs.modal", this.fecharModal);

        this.carregarInquilino();

        this.montarProdutos();
    }

}


</script>

<style scoped>

</style>
